import { __awaiter } from '../../../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { isBrowser } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { IconLlmPin } from '@websolutespa/bom-mixer-icons';
import { useLlm } from '../../../useLlm/useLlm.js';
import { Cta } from '../../components/Cta/cta.js';

const TripAdvisor = props => {
  const {
    item
  } = props;
  const label = useLabel();
  const {
    decorateUrl
  } = useLlm(state => state.actions);
  const onBookNow = event => __awaiter(void 0, void 0, void 0, function* () {
    if (isBrowser) {
      event.preventDefault();
      window.open(item.book, '_blank');
    }
  });
  const onGoToWebsite = event => __awaiter(void 0, void 0, void 0, function* () {
    if (isBrowser) {
      event.preventDefault();
      const url = yield decorateUrl(item, item.url);
      window.open(url, '_blank');
    }
  });
  return jsx("div", {
    className: "llm__tripadv",
    children: jsxs("div", {
      className: "llm__tripadv-inner",
      children: [item.image && jsx("div", {
        className: "llm__tripadv-media",
        children: jsx("img", {
          src: item.image,
          alt: ""
        })
      }), jsxs("div", {
        className: "llm__tripadv-content",
        children: [item.title && jsx("div", {
          className: "llm__tripadv-title",
          children: item.title
        }), item.rating && jsxs("div", {
          className: "llm__tripadv-rating",
          children: [jsx("span", {
            className: "llm__tripadv-dots",
            children: jsx("span", {
              style: {
                width: `${item.rating / 5 * 100}%`
              }
            })
          }), item.reviews && jsxs("span", {
            children: [item.reviews, " ", label('llm.reviews')]
          })]
        }), jsx("div", {
          className: "llm__tripadv-info",
          children: jsxs("span", {
            className: "llm__tripadv-cuisine",
            children: [`${item.priceRange}, `, item.cuisine]
          })
        }), item.address && jsxs("div", {
          className: "llm__tripadv-location",
          children: [jsx(IconLlmPin, {}), " ", item.address]
        }), jsxs("div", {
          className: "llm__tripadv-ctas",
          children: [item.book && jsx(Cta, {
            type: "button",
            label: label('llm.bookNow'),
            onClick: onBookNow
          }), jsx(Cta, {
            type: "text",
            label: label('llm.goToWebsite'),
            onClick: onGoToWebsite
          })]
        }), jsx("div", {
          className: "llm__tripadv-icon",
          children: jsxs("svg", {
            role: "img",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg",
            children: [jsx("title", {
              children: "Tripadvisor"
            }), jsx("path", {
              d: "M12.006 4.295c-2.67 0-5.338.784-7.645 2.353H0l1.963 2.135a5.997 5.997 0 0 0 4.04 10.43 5.976 5.976 0 0 0 4.075-1.6L12 19.705l1.922-2.09a5.972 5.972 0 0 0 4.072 1.598 6 6 0 0 0 6-5.998 5.982 5.982 0 0 0-1.957-4.432L24 6.648h-4.35a13.573 13.573 0 0 0-7.644-2.353zM12 6.255c1.531 0 3.063.303 4.504.903C13.943 8.138 12 10.43 12 13.1c0-2.671-1.942-4.962-4.504-5.942A11.72 11.72 0 0 1 12 6.256zM6.002 9.157a4.059 4.059 0 1 1 0 8.118 4.059 4.059 0 0 1 0-8.118zm11.992.002a4.057 4.057 0 1 1 .003 8.115 4.057 4.057 0 0 1-.003-8.115zm-11.992 1.93a2.128 2.128 0 0 0 0 4.256 2.128 2.128 0 0 0 0-4.256zm11.992 0a2.128 2.128 0 0 0 0 4.256 2.128 2.128 0 0 0 0-4.256z"
            })]
          })
        })]
      })]
    })
  });
};
const TripAdvisorGroup = props => {
  const {
    item
  } = props;
  return jsx("div", {
    className: "llm__tripadvisor-group llm__row",
    children: item.items.map((item, i) => jsx("div", {
      className: "llm__col --md-6",
      children: jsx(TripAdvisor, Object.assign({}, props, {
        item: item
      }), i)
    }))
  });
};

export { TripAdvisor, TripAdvisorGroup };
//# sourceMappingURL=tripadvisor.js.map
